import axios from "axios";
import { deleteItemWithPosition, swapAndChangePosition } from "@/utils";
import { processAxiosNetworkError } from "@/notify";
import { MAX_PAGE_SIZE } from "@/constants";

export default {
  namespaced: true,
  state: {
    preferences: [],
    isPreferencesFetching: false,
    isPreferencesFetched: false,
  },
  mutations: {
    setPreferences: function (state, preferences) {
      state.preferences = preferences;
    },
    setPreferencesFetching: function (state, isPreferencesFetching) {
      state.isPreferencesFetching = isPreferencesFetching;
    },
    setPreferencesFetched: function (state, isPreferencesFetched) {
      state.isPreferencesFetched = isPreferencesFetched;
    },
    swapPreferences: function (state, { firstPosition, secondPosition }) {
      state.preferences = swapAndChangePosition(
        state.preferences,
        firstPosition,
        secondPosition,
      );
    },
    addPreference: function (state, preference) {
      state.preferences = [...state.preferences, preference];
    },
    updatePreference: function (state, preference) {
      state.preferences = state.preferences.map((p) => {
        if (p.id === preference.id) {
          return preference;
        }
        return p;
      });
    },
    deletePreference: function (state, preference) {
      state.preferences = deleteItemWithPosition(state.preferences, preference.position);
    },
  },
  getters: {
    preferences(state) {
      return state.preferences;
    },
    preferencesOptions(state) {
      return state.preferences.map((p) => ({
        text: p.label,
        value: p.id,
      }));
    },
    labelForPreference(state) {
      return (preferenceId) => {
        const found = state.preferences.find((item) => item.id === preferenceId);
        return found && found.label;
      };
    },
  },
  actions: {
    fetchPreferences(context) {
      if (context.state.isPreferencesFetching || context.state.isPreferencesFetched) {
        return;
      }
      context.commit("setPreferencesFetching", true);
      return axios
        .get("/email-preferences/", { params: { page_size: MAX_PAGE_SIZE } })
        .then(
          (response) => {
            context.commit("setPreferencesFetching", false);
            context.commit("setPreferencesFetched", true);
            context.commit("setPreferences", response.data.results);
          },
          (error) => {
            context.commit("setPreferencesFetching", false);
            processAxiosNetworkError(error);
          },
        );
    },
  },
};
